export const types = {
  ON_CHANGE_ROLE: 'ON_CHANGE_ROLE',
  ON_CHANGE_CAMPUS: 'ON_CHANGE_CAMPUS'
};

export const onChangeRole = roleType => dispatch =>
  dispatch({
    type: types.ON_CHANGE_ROLE,
    roleType
  });

export const onChangeCampus = campusType => dispatch =>
  dispatch({
    type: types.ON_CHANGE_CAMPUS,
    campusType
  });



// WEBPACK FOOTER //
// ./src/actions/role.js